import React from 'react';
import { CaseStudyDetail } from '../components/CaseStudyDetail';
import { DeviceVideoPair } from '../components/DeviceVideoPair';
import { caseStudies } from '../data/caseStudies';
import { hotelplannerDesktopVideo, hotelplannerIntro, hotelplannerMetrics, hotelplannerSections } from '../data/hotelplannerCaseStudy';
export function HotelPlannerCaseStudy() {
  const card = caseStudies.find(s => s.id === 'hotelplanner');
  const mobileVideo = card?.videos?.[0];
  const media = mobileVideo ? <DeviceVideoPair background={hotelplannerIntro.background} label="HotelPlanner hotel page on mobile and desktop" mobile={{
    src: mobileVideo,
    poster: card?.images[0],
    label: 'HotelPlanner hotel page on mobile'
  }} desktop={{
    src: hotelplannerDesktopVideo,
    label: 'HotelPlanner hotel page on desktop'
  }} data-id="element-179" data-mp="3kafmzrdu6amr" /> : undefined;
  return <CaseStudyDetail id="hotelplanner" intro={hotelplannerIntro} images={[]} metrics={hotelplannerMetrics} sections={hotelplannerSections} media={media} data-id="element-180" data-mp="31kpuxc1gk2yj" />;
}